import Box from '@redbubble/design-system/src/Box';
import Button from '@redbubble/design-system/src/Button';
import * as constants from '@redbubble/design-system/src/constants';
import CrossDiscIcon from '@redbubble/design-system/src/Icons/CrossDisc';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { RefObject } from 'react';
import styles from './RemoveButton.module.scss';

export const messages = defineMessages({
  showRemoveConfirmationText: {
    defaultMessage: 'Show remove confirmation button',
  },
  hideRemoveConfirmationText: {
    defaultMessage: 'Hide remove confirmation button',
  },
  removeText: {
    defaultMessage: 'Remove',
  },
});

interface RemoveButtonProps {
  onRemoveConfirm: () => void;
  toggleShowConfirm: (isOpen: boolean) => void;
  confirmButtonRef: RefObject<HTMLButtonElement>;
  showRemoveConfirm?: boolean;
}

export const RemoveButton = ({
  onRemoveConfirm,
  toggleShowConfirm,
  confirmButtonRef,
  showRemoveConfirm,
}: RemoveButtonProps) => {
  const intl = useIntl();

  return (
    <>
      <Box className={styles.removeBtnWrapper}>
        <Button
          onClick={() => {
            toggleShowConfirm(!showRemoveConfirm);
          }}
          size={constants.SMALL}
          iconBefore={
            // TODO: need to pass in aria-hidden when [DEP-1036] has been completed
            <CrossDiscIcon size={constants.MEDIUM} />
          }
          aria-label={
            showRemoveConfirm
              ? intl.formatMessage(messages.hideRemoveConfirmationText)
              : intl.formatMessage(messages.showRemoveConfirmationText)
          }
          circle
        />
      </Box>

      <button
        className={[
          styles.removeConfirmBtn,
          showRemoveConfirm && styles.showRemoveConfirm,
        ]
          .filter(Boolean)
          .join(' ')}
        ref={confirmButtonRef}
        disabled={!showRemoveConfirm}
        onClick={onRemoveConfirm}
        type="button"
      >
        <Text type="display5">{intl.formatMessage(messages.removeText)}</Text>
      </button>
    </>
  );
};
